<template>
  <div style="max-width:300px">
    <b-alert
      class="text-center"
      style="margin-top:15px"
      v-model="visible"
      variant="success"
    >Hasło zostało ustawione poprawnie.</b-alert>

    <div class="text-right">
      <b-button variant="link" @click="goto('/public/login')">Wróć do strony logowania</b-button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goto(url) {
      this.$router.push(url);
    }
  },
  data() {
    return {
      visible: true
    };
  }
};
</script>

<style lang="scss" scoped>
.btn {
  &.btn-link {
    font-size: 0.75rem;
    text-decoration: none;
  }
}
</style>
